import type { HTMLAttributes } from "react";
import { createElement, forwardRef } from "react";

import styles from "./WebComponent.module.scss";

type WebComponentProps = {
  tagName: string;
  error?: string;
} & HTMLAttributes<HTMLDivElement>;

export const WebComponent = forwardRef<HTMLDivElement, WebComponentProps>(({ tagName, ...restProps }, ref) => {
  // Pass the ref directly to the WebComponent
  const webComponentElement = createElement(tagName, { ...restProps, ref });

  return <div className={styles.wrapper}>{webComponentElement}</div>;
});
